module.exports = __webpack_public_path__ + "static/img/bg.723fe8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/bg.png
// module id = 0Rdh
// module chunks = 1